export default __webpack_public_path__ + "static/media/approach.8598535f.jpg";